// ==============================|| PHYSIO ROUTES ||============================== //

export const BASE_PATH_TO_PHYSIO_LIST = "/physio/list";
export const BASE_PATH_TO_PHYSIO_VIDEO_SESSIONS = "/physio/video-sessions";

